import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import HtmlHead from '../../components/01_atoms/HtmlHead';
import CorporateGiftPage from '../../componentsGifts/CorporateGiftPage';
import { pushEcommerceDetail as gtmPushEcommerceDetail } from '../../utils/Gifts/gtm';

import '../../styles/gifts/sass/theme.scss';

const GiftsCorporateProductPage = ({ entity: product }) => {
  useEffect(() => {
    gtmPushEcommerceDetail(product);
  }, []);

  return (
    <div>
      <HtmlHead metatags={product.metaTags} pageTitle={product.title} />
      <CorporateGiftPage gift={product} />
    </div>
  );
};

GiftsCorporateProductPage.propTypes = {
  entity: PropTypes.object.isRequired,
};

export default GiftsCorporateProductPage;
